//#region Styles
import { Row } from "components/styles";
import {
    Container, 
    Title 
} from "../../../styles";
//#endregion
//#region Components
import CampusSearchField from "./components/CampusSearchField/CampusSearchField";
import CustomSelect from "components/CustomSelect/CustomSelect";
import { getOptionsToCustomSelect } from "components/CustomSelect/utils";
//#endregion

const LocationPlaceStep1 = ({
    dataRelatedToForm: {
        allCampusDetail,
        environmentTypeList
    },
    form, errors,
    changeField
}) => {
    const { campus, environmentTypeId } = form;
    //#region Functions
    const changeCampus = value => {
        changeField("campus", {
            ...value,
            name: value.text
        }, false);
    }
    const changeEnvironmentTypeId = value => {
        changeField("environmentTypeId", value, false);
    }
    //#endregion
    return (
        <Container>
            <Title>Paso 01:</Title>
            <Row>
                <CampusSearchField 
                    allCampus={allCampusDetail}
                    campus={campus}
                    changeCampus={changeCampus}
                    error={errors.campus}/>
                <CustomSelect
                    label="Tipo de ambiente"
                    value={environmentTypeId}
                    onChange={changeEnvironmentTypeId}
                    optionsProps={getOptionsToCustomSelect(environmentTypeList, { id: "id", text: "name" })}
                    error={errors.environmentTypeId}
                    errorText="Es necesario seleccionar un tipo de ambiente"
                    defaultOptionText="Selecciona un tipo"/>
            </Row>
        </Container>
    );
}

export default LocationPlaceStep1;